import { supabase } from '../supabase';

export async function verifyEmail(token?: string): Promise<boolean> {
  try {
    // In Supabase, email verification is handled automatically via the link sent to the user
    // This function would be used to check if a user's email is verified
    const { data, error } = await supabase.auth.getUser();
    
    if (error) {
      console.error('Error checking email verification status:', error);
      return false;
    }
    
    return !!data.user?.email_confirmed_at;
  } catch (error) {
    console.error('Email verification error:', error);
    return false;
  }
}

export async function resendVerificationEmail(email: string): Promise<void> {
  try {
    // First check if the user exists and is already verified
    const { data: userData, error: userError } = await supabase.auth.signInWithOtp({
      email: email,
      options: {
        shouldCreateUser: false
      }
    });
    
    if (userError) {
      console.error('Error checking user before resending verification:', userError);
      throw new Error(userError.message);
    }
    
    console.log(`Verification email sent to: ${email}`);
  } catch (error) {
    console.error('Resend verification email error:', error);
    throw error;
  }
}